module.exports = __webpack_public_path__ + "static/media/delvalleport.91932ad7.jpeg";